import { apiClient } from '../../../gateways/api'
import type { PlanningPreview } from '../types/PlanningPreview'

export { fetchPlanningPreview }

const fetchPlanningPreview = async ({
  id,
  startUitvoeringWeek,
  doorlooptijdWeken,
}: {
  id: string
  startUitvoeringWeek: string
  doorlooptijdWeken: number
}): Promise<PlanningPreview> => {
  const { data } = await apiClient({
    method: 'GET',
    url: `/rest/project/${id}/planning-preview`,
    params: { startUitvoeringWeek, doorlooptijdWeken },
  })

  return data
}
